import loadData from './load-data';
import core_viz from './core-viz';
import filters from './filters';
import question_dropdowns from './question-dropdowns';
import lang from './lang';
import util from './_utils';

const container = d3.select('.graphic__chart'),
	svg = container.select('.svg__routine'),
	g = svg.select('.routine'),
	svg_lh = container.select('.svg__love-hate'),
	rightPanel = d3.select('.graphic__right'),
	header = d3.select('.viz-header'),
	bottom_panel = container.select('.bottom__panel'),
	bottom_panel_routine = bottom_panel.select('.bottom__panel-routine');

let vizParameters = null;

let colors = ['#FFFFFF', '#C4C4C4', '#808080'];

let currentPercents = [360, 360, 360];

//UPDATE DATA
let currentQuestion = 'Habit',
	currentResponses = ['Big goals', 'Habit', 'Guilt'],
	currentGender = 'Total',
	currentAge = 'Total',
	currentNationality = 'Total',
	currentWeekday = 'Both';

let allData,
	circleData,
	smallCircleR,
	bigCircleRs;

let circleGs,
	bigCircles,
	bigCircleLabels,
	smallCircleGs;

const tau = 2 * Math.PI;

let drawn = false;

let step = 0,
	isMobile;

function next(index) {
	step = index + 1;
	if (step === 0) {
		removeHighlightColor();
		filter('Habit', ['Big goals', 'Habit', 'Guilt'], 'Total', 'Total', 'Total');
		filters.set(null, null, null);
		question_dropdowns.clearSelect2();
	} else if (step === 1) {
		removeHighlightColor();
		currentWeekday = 'Both';
		filter('Time', ['Morning', 'Afternoon', 'Evening'], 'Total', 'Total', 'Total');

		bottom_panel_routine.select('.bottom__panel-routine-time').selectAll('.bottom__panel-clickable').classed('is-active', function() {
			const time = d3.select(this).attr('data-time');
			if (time === 'Both') return true;
			return false;
		});

		filters.set(null, null, null);
		question_dropdowns.clearSelect2();
	} else if (step === 2) {
		removeHighlightColor();
		filter('Coping', ['Children left home', 'Experienced a significant injury', 'Lost a loved one'], 'Total', 'Total', 'Total');
		filters.set(null, null, null);
		question_dropdowns.clearSelect2();
	};
}

function init() {
	svg.style('pointer-events', 'none');
	return new Promise((resolve, reject) => {
		Promise.all([
			loadData('routine.csv'),

		]).then(function(result) {
			allData = result[0];

			setup();
			click();
			resolve();

		}).catch(function(err) {
			console.log(err);
		})
	})
}

function setup() {
	vizParameters = getVizParameters();

	const circleMaxR = Math.min(vizParameters.width / 2.5, vizParameters.height / 2.5) - 20;
	const circleScale = d3.scaleLinear().domain([0, 1000]).range([1, 25]);

	smallCircleR = circleScale(circleMaxR);
	bigCircleRs = [circleMaxR - smallCircleR, circleMaxR - smallCircleR * 8, circleMaxR - smallCircleR * 16];

	circleData = generateCircleData(bigCircleRs, smallCircleR);
}

function click() {
	bottom_panel_routine.select('.bottom__panel-routine-time')
		.selectAll('.bottom__panel-clickable')
		.on('click', function() {
			const time = d3.select(this).attr('data-time');

			if (time === 'Weekday') currentWeekday = 'Weekday';
			if (time === 'Weekend') currentWeekday = 'Weekend';
			if (time === 'Both') currentWeekday = 'Both';

			filter();

			bottom_panel_routine.select('.bottom__panel-routine-time').selectAll('.bottom__panel-clickable').classed('is-active', false);
			d3.select(this).classed('is-active', true);
		})
}

function transition() {
	setTimeout(function() {
		build(true);
	}, 250)
}

function build(reset = false) {
	svg.style('pointer-events', 'all');
	g.selectAll('*').remove();
	container.selectAll('.big-circle-label').remove();

	circleGs = g.selectAll('.circle-g')
		.data(circleData)
		.enter()
		.append('g')
		.classed('circle-g', true);

	bigCircles = circleGs.append('path')
		.attr('transform', `translate(${vizParameters.centerX}, ${vizParameters.centerY})`)
		.datum(d => d.bigCircleData)
		.style('fill', '#4A4A4F')
		.style('opacity', 0);

	bigCircles.each(function(d, i) {
		d3.select(this).attr('d', d.arc);
	});

	if (reset) {
		removeHighlightColor();
		filter('Habit', ['Big goals', 'Habit', 'Guilt'], 'Total', 'Total', 'Total')
	} else {
		filter()
	}

	drawn = true;
}

function clear() {
	drawn = false;
	svg.style('pointer-events', 'none');
	// g.selectAll('*').remove();

	d3.selectAll('.small-circle')
		.transition().duration(250)
		.attr('r', 0).style('opacity', 0)
		.remove();

	bigCircles.each(function(d, i) {
		d3.select(this)
			.transition()
			.duration(500).delay(i * 100)
			.attrTween('d', arcTween(270, 500, -500))
			.style('opacity', 0)
			.transition().duration(0).remove();
	})

	container.selectAll('.big-circle-label').transition().duration(500).delay((d, i) => i * 50).style('opacity', 0).remove();
}

function filter(question = null, responses = null, gender = null, age = null, nationality = null) {
	if (question && question != currentQuestion) currentQuestion = question;
	if (responses && responses != currentResponses) currentResponses = responses;
	if (gender && gender != currentGender) currentGender = gender;
	if (age && age != currentAge) currentAge = age;
	if (nationality && nationality != currentNationality) currentNationality = nationality;

	const weekday = currentQuestion === 'Time' ? currentWeekday : '';

	const filteredData = allData.filter((d, i) => {
		return d.Question === currentQuestion && currentResponses.indexOf(d.Response) > -1 && d.Gender === currentGender && d.Age === currentAge && d.Nationality === currentNationality && d.Weekday === weekday;
	});

	//NEW
	const filteredResponses = filteredData.map(d => d.Response);

	currentResponses.forEach((response, index) => {
		if (filteredResponses.indexOf(response) === -1) {
			filteredData.push({
				Response: response,
				Percent: 'N/A',
			})
		}
	});

	filteredData.sort((a, b) => currentResponses.indexOf(a.Response) - currentResponses.indexOf(b.Response));

	const newLabels = filteredData.map(d => d.Percent === 'N/A' ? 'N/A' : +d.Percent)
	const newPercents = filteredData.map(d => d.Percent === 'N/A' ? 0 : +d.Percent);

	updateLabels(newLabels);
	updateCircles(newPercents);
	//
}

function updateLabels(newPercents) {
	bigCircleLabels = container.selectAll('.big-circle-label')
		.data(currentResponses, d => d);

	const bigCircleLabelsE = bigCircleLabels.enter()
		.append('div')
		.classed('big-circle-label', true)
		.style('left', `${vizParameters.centerX - 10}px`)
		.style('top', (d, i) => `${vizParameters.centerY - circleData[i].bigCircleData.r}px`)
		.style('opacity', 0)
		.style('color', (d, i) => colors[i])
		.style('max-width', `${vizParameters.width / 2 - 20}px`)

	bigCircleLabelsE.append('p')
		.text(d => lang.translateViz('routine', `Viz--${d}`))
		.style('font-weight', '200')

	bigCircleLabelsE.append('p')
		.attr('class', 'big-circle-label-pct')
		.text((d, i) => {
			if (newPercents[i] === 'N/A') return 'N/A'; 

			const spacer = lang.getCurrentLang() == 'de-DE' || lang.getCurrentLang() == 'es-ES' ? ' ' : '';
			return `${Math.round(newPercents[i] * 100)}${spacer}%`
		})
		.style('font-weight', '600')

	bigCircleLabelsE.append('svg')
		.style('transform', 'rotate(90deg)')
		.append('svg:image')
		.attr('xlink:href', './assets/images/triangle-orange.svg')
		.attr('width', '100%')
		.attr('height', '100%')
		.style('fill', '#F86214');

	bigCircleLabelsE.transition()
		.delay((d, i) => i * 250)
		.duration(500)
		.style('left', `${vizParameters.centerX}px`).style('opacity', 1);

	bigCircleLabels.select('.big-circle-label-pct')
		.text((d, i) => {
			if (newPercents[i] === 'N/A') return 'N/A'; 

			const spacer = lang.getCurrentLang() == 'de-DE' || lang.getCurrentLang() == 'es-ES' ? ' ' : '';
			return `${Math.round(newPercents[i] * 100)}${spacer}%`
		});

	bigCircleLabels.exit()
		.transition()
		.duration(500)
		.style('left', `${vizParameters.centerX + 10}px`)
		.style('opacity', 0)
		.remove();
}

function updateCircles(newPercents, delay = 2000) {
	smallCircleGs = circleGs.selectAll('.small-circle-g')
		.data((d, i) => {
			d.smallCircleData.forEach(d => {
				d.index = i;
			});
			return d.smallCircleData.filter(circleData => circleData.pct < newPercents[i]);
		})

	const smallCircleGsE = smallCircleGs.enter()
		.append('g')
		.classed('small-circle-g', true)
	// .attr('visibility', 'hidden');

	smallCircleGsE.selectAll('.small-circle')
		.data((d, i) => {
			d.circleCoords.forEach(s => {
				s.index = i;
				s.parentIndex = d.index;
			})
			return d.circleCoords
		})
		.enter()
		.append('circle')
		.attr('class', 'small-circle')
		.attr('cx', d => d.x).attr('cy', d => d.y).attr('r', 0)
		.style('opacity', 0)
		.transition().duration(500)
		.delay((d, i) => {
			let thisDelay = i * 20
			if (d.parentIndex == 0) thisDelay = d.index * 10 + i * 20;
			if (d.parentIndex == 1) thisDelay = d.index - circleData[0].smallCircleData.length - 1 * 10 + i * 20;
			if (d.parentIndex == 2) thisDelay = d.index - circleData[1].smallCircleData.length - 1 - circleData[2].smallCircleData.length - 1 * 10 + i * 20;
			return thisDelay;
		})
		// .delay((d, i) => (d.pct - currentPercents[d.bigCircleIndex]) * delay)
		.attr('r', smallCircleR).style('opacity', 1)
		.attr('fill', d => colors[d.parentIndex]);

	smallCircleGsE
		// .transition()
		// .delay((d, i) => (d.pct - currentPercents[d.bigCircleIndex]) * delay)
		// .duration(100)
		// .style('visibility', 'visible')
		.attr('stroke', '#242428')
		.attr('stroke-width', '.5');

	smallCircleGs.selectAll('.small-circle')
		.transition()
		.duration(500)
		.attr('fill', d => {
			return colors[d.parentIndex]
		});

	smallCircleGs.exit()
		.transition().duration(500)
		.delay(d => (newPercents[d.bigCircleIndex] - d.pct) * delay)
		.attr('r', 0).style('opacity', 0)
		.remove();

	bigCircles.each(function(d, i) {
		d3.select(this)
			.transition()
			.duration(drawn ? (Math.abs(newPercents[i] - currentPercents[i]) * delay) : 1000).delay(drawn ? 0 : i * 100)
			.attrTween('d', arcTween(newPercents[i] * tau, 1000, -1000))
			.style('opacity', 1);
	})

	currentPercents = newPercents;
}

function addHighlightColor() {
	colors = ['#FFFFFF', '#C4C4C4', '#F8621F'];
}

function removeHighlightColor() {
	colors = ['#FFFFFF', '#C4C4C4', '#808080'];
}

function generateCircleData(bigCircleRs, smallCircleR) {
	const circleData = bigCircleRs.map((r, i) => {
		const smallCircleData = generateSmallCircleData(r, smallCircleR, i),
			bigCircleData = generateBigCircleData(r);

		return {
			bigCircleData,
			smallCircleData,
		}
	})

	return circleData;
}

function generateBigCircleData(bigCircleR) {
	const startAngle = .9 * tau,
		endAngle = .9 * tau;

	const arc = d3.arc()
		.innerRadius(bigCircleR - .5)
		.outerRadius(bigCircleR + .5)
		.endAngle(endAngle);

	return {
		r: bigCircleR,
		startAngle,
		endAngle,
		arc,
	}
}

function generateSmallCircleData(bigCircleR, smallCircleR, bigCircleIndex) {
	const outerCircleR = bigCircleR + smallCircleR,
		innerCircleR = bigCircleR - smallCircleR,
		innerCircleCircumference = 2 * Math.PI * innerCircleR,
		innerCircleCount = Math.floor(innerCircleCircumference / (smallCircleR * 2)),
		circleAngle = 360 / innerCircleCount;

	const circles = [];

	let i = 0;

	while (i < innerCircleCount) {
		const angleDeg = -(circleAngle * i),
			angleRad = (angleDeg + 90) * Math.PI / 180;

		const innerCircleCoords = generateCircleCoords(angleDeg, angleRad, innerCircleR),
			outerCircleCoords = generateCircleCoords(angleDeg, angleRad, outerCircleR),
			circleCoords = [innerCircleCoords, outerCircleCoords];

		circles.push({
			bigCircleIndex,
			circleCoords,
			pct: i / innerCircleCount,
			fill: colors[bigCircleIndex],
			response: currentResponses[bigCircleIndex],
		})

		i++;
	}

	return circles;
}

function generateCircleCoords(angleDeg, angleRad, radius) {
	const x = (vizParameters.centerX) + (radius * Math.cos(angleRad)),
		y = (vizParameters.centerY) - (radius * Math.sin(angleRad));

	return {
		x,
		y,
	};
}

function getVizParameters() {
	isMobile = util.isMobile();

	const parameters = {};

	const container_width = container.node().offsetWidth,
		container_height = container.node().offsetHeight,
		header_height = header.node().offsetHeight + 10,
		panel_width = rightPanel.node().offsetWidth,
		panel_height = rightPanel.node().offsetHeight,
		bottom_panel_height = getBottomPanelHeight();

	parameters.yOffset = header_height;
	parameters.fullWidth = container_width;
	parameters.fullHeight = container_height - bottom_panel_height - parameters.yOffset;
	parameters.fullCenterX = parameters.fullWidth / 2;
	parameters.fullCenterY = parameters.fullHeight / 2 + parameters.yOffset;
	parameters.fullBottomY = container_height + container_height * .1;

	if (!isMobile) {
		const adjusted_width = container_width - panel_width;

		parameters.width = adjusted_width;
		parameters.height = parameters.fullHeight;

		parameters.centerX = adjusted_width / 2;
		parameters.centerY = parameters.fullCenterY;

	} else {
		// const adjusted_height = container_height - panel_height - 56;
		const adjusted_height = (container_height / 2) - header_height;

		parameters.width = parameters.fullWidth;
		parameters.height = adjusted_height;

		parameters.centerX = parameters.fullCenterX;
		parameters.centerY = parameters.fullCenterY - (panel_height / 2) + 56;
	}

	return parameters;
}

function getBottomPanelHeight() {
	const bottom_panel_height = bottom_panel.node().offsetHeight;

	bottom_panel_routine.style('display', 'flex');
	const bottom_panel_routine_height = bottom_panel_routine.node().offsetHeight + 10;
	bottom_panel_routine.style('display', '');

	return bottom_panel_height + bottom_panel_routine_height;
}

function arcTween(newAngle) {
	return function(d) {
		var interpolate = d3.interpolate(d.startAngle, newAngle);
		return function(t) {
			d.startAngle = interpolate(t);
			return d.arc(d);
		};
	};
}

export default {
	init,
	setup,
	build,
	clear,
	transition,
	next,
	filter,
	addHighlightColor,
}